import { BankDetailsRequest, BankDetailsResponseModel, BankIdReq, CompanyReq } from "@gtpl/shared-models/masters"
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages"
import { Controller, Post, Body } from "@nestjs/common"
import { ApiTags } from "@nestjs/swagger"
import { BankDetailsService } from "./bank-details-service"
import { CommonResponse } from "@gtpl/shared-models/production-management"

@ApiTags('bank-details')
@Controller('bank-details')
export class BankDetailsController{
    constructor(
        private service:BankDetailsService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ){}
    @Post('/createBankDetails')
    async createBankDetails(@Body() req:BankDetailsRequest,updated:boolean):Promise<BankDetailsResponseModel>{
        try{
            console.log(req,'conrollerrrrrrrrrrrrrrrrrr');
            
            return await this.service.createBankDetails(req,updated)
        }catch(err){
            return this.applicationExceptionhandler.returnException(BankDetailsResponseModel,err)
        }
    }
    @Post('/getAllBankDetailsInfo')
    async getAllBankDetailsInfo():Promise<BankDetailsResponseModel>{
        try{
            return await this.service.getAllBankDetailsInfo()
        }catch(err){
            return this.applicationExceptionhandler.returnException(BankDetailsResponseModel,err)
        }
    }
    @Post('/updateBankDetails')
    async updateBankDetails(@Body() req:BankDetailsRequest,isUpdate:boolean=true): Promise<BankDetailsResponseModel> {
        try {
         return await this.service.createBankDetails(req,isUpdate);
       } catch (error) {
            return this.applicationExceptionhandler.returnException(BankDetailsResponseModel, error);
       }
     }
     @Post('/activateOrDeactivateBankDetails')
     async activateOrDeactivateBankDetails(@Body() req: BankDetailsRequest): Promise<BankDetailsResponseModel> {
         try {
            console.log('controllerrrrrrr',req);
            
             return await this.service.activateOrDeactivate(req);
         } catch (err) {
             return this.applicationExceptionhandler.returnException(BankDetailsResponseModel, err);
         }
     }

     @Post('/getBankDetailsByCompany')
     async getBankDetailsByCompany(@Body() req: CompanyReq): Promise<CommonResponse> {
         try {
             return await this.service.getBankDetailsByCompany(req);
         } catch (err) {
             return this.applicationExceptionhandler.returnException(CommonResponse, err);
         }
     }
     @Post('/getBankDetailsById')
     async getBankDetailsById(@Body() req: BankIdReq): Promise<CommonResponse> {
         try {
             return await this.service.getBankDetailsById(req);
         } catch (err) {
             return this.applicationExceptionhandler.returnException(CommonResponse, err);
         }
     }
}